import { render } from "./MetierFormations.vue?vue&type=template&id=9a53ca12&scoped=true"
import script from "./MetierFormations.vue?vue&type=script&lang=js"
export * from "./MetierFormations.vue?vue&type=script&lang=js"

import "./MetierFormations.vue?vue&type=style&index=0&id=9a53ca12&lang=scss&scoped=true"

import exportComponent from "C:\\projets\\salon-metiers-2026\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a53ca12"]])

export default __exports__